export default __webpack_public_path__ + "static/media/icon-thumb-new.ab53c6d7.svg";